import { render, staticRenderFns } from "./JVxeSubPopover.vue?vue&type=template&id=4a229f70&scoped=true&"
import script from "./JVxeSubPopover.vue?vue&type=script&lang=js&"
export * from "./JVxeSubPopover.vue?vue&type=script&lang=js&"
import style0 from "./JVxeSubPopover.vue?vue&type=style&index=0&id=4a229f70&scoped=true&lang=less&"
import style1 from "./JVxeSubPopover.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a229f70",
  null
  
)

export default component.exports